import styled from "styled-components";

const PageLinking = styled.div`
  display: block;
  line-height: 1.4;
  font-size: 16px;
`;
export default PageLinking;
